export const useDynatraceScript = (): undefined => {
  const appEnv: string = process.env.REACT_APP_ENV as string;

  switch (appEnv) {
    case 'production':
      return require('../../scripts/dynatrace/prodSnippet.js');
    case 'staging':
      return require('../../scripts/dynatrace/stagingSnippet.js');
    case 'qa':
      return require('../../scripts/dynatrace/qaSnippet.js');
    case 'dev':
      return require('../../scripts/dynatrace/devSnippet.js');
  }

  return;
};
